var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offside-div"},[_c('h3',{staticClass:"manutencao text-center"},[_vm._v(" Mercado Fechado")]),_c('img',{staticClass:"offside",attrs:{"src":"https://images2.imgbox.com/11/86/u7fpusqz_o.png"}})])
}]

export { render, staticRenderFns }